import React, { useEffect, useState } from "react";
import Wrapper from "../../../components/Wrapper/Wrapper";
import { Box, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";
import { WISE_ADMIN_TABLE_HEAD as columns } from "../../../components/datagrid/CRM/WiseAdmin/WiseAdminTableHead";
import { useDispatch, useSelector } from "react-redux";
import { wiseAdminget } from "../../../redux/features/crmSlice";

export default function WiseAdmin() {
    const dispatch = useDispatch();
    const { wiseAdmin, loading } = useSelector((state) => state.crm);
    const [gridSize, setGridSize] = useState(5);
    useEffect(() => {
        dispatch(wiseAdminget());
    }, []);
    return (
        <Wrapper
            title="Wise Admin"
            Content={
                <>
                    <Paper elevation={3}>
                        <Box>
                            <DataGrid
                                loading={loading}
                                rows={wiseAdmin}
                                columns={columns}
                                columnBuffer={30}
                                pageSize={gridSize}
                                autoHeight
                                onPageSizeChange={(newGridSize) =>
                                    setGridSize(newGridSize)
                                }
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                getRowId={(row) => {
                                    return row.serialNumber;
                                }}
                                components={{
                                    Toolbar: CustomGridToolbar,
                                }}
                                componentsProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: {
                                            debounceMs: 500,
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </Paper>
                </>
            }
        />
    );
}
